if (!customElements.get('sp-perday')) {
  customElements.define(
    'sp-perday',
    class extends HTMLElement {
      connectedCallback() {
        let map = {};
        try {
          map = JSON.parse(this.querySelector('[data-map]').textContent);
        } catch (e) {}
        const form = document.getElementById(this.dataset.form);
        const text = this.querySelector('.sp-perday__text');
        const pd = this.querySelector('[data-pd]');
        const days = this.querySelector('[data-days]');
        if (!form || !text) return;

        const update = () => {
          const idInput = form.querySelector('[name="id"]');
          const id = idInput ? idInput.value : null;
          const entry = id ? map[id] : null;
          if (entry && entry.days > 0) {
            if (pd) pd.textContent = entry.pd;
            if (days) days.textContent = entry.days;
            text.hidden = false;
          } else {
            text.hidden = true;
          }
        };

        form.addEventListener('change', () => setTimeout(update, 0));
        update();
      }
    }
  );
}
